import { rateGuarantee } from "./sharedTypedAmount";

import type { TypedAmountTypeOption } from "../typedAmountTypes";

const NOT_INCLUDED: TypedAmountTypeOption = {
  value: "notIncluded",
  label: "Not Included",
  hideAmount: true,
};
const NOT_DISCLOSED: TypedAmountTypeOption = {
  value: "notDisclosed",
  label: "Not Disclosed",
  hideAmount: true,
};

const FML_TYPE_OPTIONS: TypedAmountTypeOption[] = [
  { value: "paid", label: "Paid" },
  { value: "unpaid", label: "Unpaid" },
  {
    value: "includedInBasePrice",
    label: "Included in Base Price",
    hideAmount: true,
  },
  NOT_INCLUDED,
  NOT_DISCLOSED,
];

export interface FmlTypedAmountSpec {
  typeKey: string;
  amountKey: string;
  amountLabel: string;
  typeOptions: TypedAmountTypeOption[];
  amountMin?: number;
  amountInteger?: boolean;
}

export const fmlTypedAmountFields: Record<string, FmlTypedAmountSpec> = {
  federalFmla: {
    typeKey: "federalFmlaType",
    amountKey: "federalFmlaAmount",
    amountLabel: "Amount",
    typeOptions: FML_TYPE_OPTIONS,
  },
  unpaidStateLeaves: {
    typeKey: "unpaidStateLeavesType",
    amountKey: "unpaidStateLeavesAmount",
    amountLabel: "Amount",
    typeOptions: FML_TYPE_OPTIONS,
  },
  militaryUserra: {
    typeKey: "militaryUserraType",
    amountKey: "militaryUserraAmount",
    amountLabel: "Amount",
    typeOptions: FML_TYPE_OPTIONS,
  },
  juryDuty: {
    typeKey: "juryDutyType",
    amountKey: "juryDutyAmount",
    amountLabel: "Amount",
    typeOptions: FML_TYPE_OPTIONS,
  },
  ada: {
    typeKey: "adaType",
    amountKey: "adaAmount",
    amountLabel: "Amount",
    typeOptions: FML_TYPE_OPTIONS,
  },
  rateGuarantee,
};
